module.exports = __webpack_public_path__ + "img/portrait-030.795640ee.jpg";